







import { Component, Prop, Vue } from 'vue-property-decorator';
import AuthService from '@/services/auth';
import ModalService from '@/services/modal';
import PurchaseService from '@/services/purchase';
import Car from '@/entities/Car';
import CarService from '@/services/car';
import BidService from '@/services/bid';
import Variables from '@/config/variables';
import Formatter from '@/support/formatter';

@Component
export default class BuyNow extends Vue {
    @Prop()
    car: Car;

    authService = new AuthService();

    modalService = new ModalService();

    purchaseService = new PurchaseService();

    carService = new CarService();

    bidService = new BidService();

    variables = new Variables();

    formatter = new Formatter();

    get price() {
        return this.car.priceString;
    }

    public buyNow() {
        if (!this.authService.isLoggedIn) {
            return this.modalService.showLoginModal();
        }
        if (!this.authService.currentUser.canBuy) {
            return this.modalService.showNeedProfileUpdateModal();
        }

        return this.modalService.showConfirmationModal(
            this.$t('buy_now.confirm.title').toString(),
            this.getConfirmBuyNowContentOverview(this.car.price),
            () => this.congratulate(),
            this.$t('buy_now.confirm.confirm').toString(),
        );
    }

    private getConfirmBuyNowContentOverview(amountToSubmit: number): string {
        const calculated = this.bidService.calculate(amountToSubmit, this.car);

        return `
            <div>${this.$t(`details.${this.car.vatDeductible ? 'net_price' : 'price'}`)}: <strong>${calculated.amount.formatted}</strong></div>
            <div class="${this.car.vatDeductible ? '' : 'hidden'}">${this.$t('details.vat', { vat: this.variables.vat })}: <strong>${calculated.vat.formatted}</strong></div>
            <div>${this.$t('details.fee')}: <strong>${calculated.fee.formatted}</strong></div>
            <div class="mb-4">${this.$t('details.grand_total')}: <strong>${calculated.total.formatted}</strong></div>
        `;
    }

    public congratulate() {
        this.purchaseService.addPurchase(this.car.id).then(() => {
            this.carService.markSold(this.car);
            setTimeout(() => {
                this.modalService.showInfoModal(
                    this.$t('buy_now.thanks.title').toString(),
                    this.$t('buy_now.thanks.content').toString(),
                );
            }, 500);
        });
    }
}
